import { render, staticRenderFns } from "./off_shelf_rule.vue?vue&type=template&id=5777c404&scoped=true&"
import script from "./off_shelf_rule.vue?vue&type=script&lang=js&"
export * from "./off_shelf_rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777c404",
  null
  
)

export default component.exports